import './_progressBar.scss';

const ProgressBar = (props) => {
    const progressBarRef = props.progressBarRef;
    const audioRef = props.audioRef;
    const timeProgress = props.timeProgress;
    const duration = props.duration;
    // const setIsPlaying = props.setIsPlaying;

    const handleProgressChange = () => {
        audioRef.current.currentTime = progressBarRef.current.value;
    };

    const formatTime = (time) => {
        if (time && !isNaN(time)) {
            const minutes = Math.floor(time / 60);
            const formatMinutes =
                minutes < 10 ? `0${minutes}` : `${minutes}`;
            const seconds = Math.floor(time % 60);
            const formatSeconds =
                seconds < 10 ? `0${seconds}` : `${seconds}`;
            return `${formatMinutes}:${formatSeconds}`;
        }
        return '00:00';
    };
    return (
        <div className="progress2">
            <span className="time current">{formatTime(timeProgress)}</span>
            <input
                type="range"
                ref={progressBarRef}
                defaultValue="0"
                onChange={handleProgressChange}
            //     onKeyDown={(e) => {
            //         if (e.code === "Enter") {
            //             setIsPlaying((prev) => !prev);
            //         }
            //         else if (e.code === "Space") {
            //             e.preventDefault();
            //             setIsPlaying((prev) => !prev);
            //         }
            //     }
            // }
            />
            <span className="time">{formatTime(duration)}</span>
        </div>
    );
};

export default ProgressBar;